/**
 * Ember · 星火 管理后台 — React 18 入口
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import App from './App';
import { installGlobalErrorHandlers } from './observability/report';
import './styles/tokens.css';
import './styles/owner-dashboard-tokens.css';
import './styles/globals.css';

installGlobalErrorHandlers();
dayjs.locale('zh-cn');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
